import { useCallback } from 'react';
import { useTracking } from './TrackingContext';
import { publish } from './pubsub';

export function useTravelGuideTracking() {
  const container = useTracking();
  const { eventType } = container;

  const track = useCallback(
    (_, action) => {
      const send = (name: string, changes: Record<string, unknown>) => {
        publish(name, {
          ...changes
        });
      };
      switch (action.type) {
        case 'SELECT_INTEREST': {
          return send(`em.${eventType}.interest`, action.payload);
        }
        case 'SELECT_ARTICLE': {
          return send(`em.${eventType}.article`, action.payload);
        }
        case 'CLICK_OUT_EVENTS': {
          return send(`em.fare.${eventType}.link`, action.payload);
        }
      }
    },
    [eventType]
  );

  return track;
}
